var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mv3"},[_c('p',[_vm._v("Your payment was "+_vm._s(_vm.message))]),_c('p',{staticClass:"i"},[_vm._v(" Logging you out in 10secs... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }